<template>
  <div class="control-legend">
    <!-- legend title -->
    <legend-title icon-name="filter" :title="legendTitle" class="control-legend__title" />

    <!-- legend list -->
    <ul class="control-legend__list">
      <li v-for="item in legends" :key="item.name" class="control-legend__item">
        <div
          :data-value="item.name"
          :class="{ 'legend-item--active': item.name === lazyValue || lazyValue === 'All' }"
          class="legend-item"
          @click="updateLazyValue"
        >
          <div :data-value="item.name" :style="{ 'background-color': item.color }" class="legend-item__icon" />
          <span :data-value="item.name" class="text-legend">{{ item.name }}</span>
        </div>
      </li>

      <!-- reset to All -->
      <li class="control-legend__item control-legend__item--reset">
        <div
          data-value="All"
          class="legend-item legend-item--active text-small text--darkgrey"
          @click="updateLazyValue"
        >
          <i class="fal fa-redo legend-item__icon" />
          <span data-value="All" class="text-legend">{{ resetLabel }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import LegendTitle from '@/components/ui/LegendTitle.vue';

export default {
  name: 'ListLegendFilter',
  components: {
    LegendTitle,
  },
  props: {
    legends: {
      type: Array,
      required: true,
    },
    legendTitle: String,
    resetLabel: String,
    value: null,
  },
  data() {
    return {
      lazyValue: this.value,
    };
  },
  methods: {
    updateLazyValue(e) {
      // get selected value
      const { value } = e.target.dataset;

      // update value
      if (this.lazyValue === value) {
        this.lazyValue = 'All';
      } else {
        this.lazyValue = value;
      }
      // emit value
      this.$emit('filter:legend', this.lazyValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.control-legend {
  margin: 15px 0;

  &__title {
    margin-bottom: 10px;
  }

  .control-legend__list {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    margin: -5px -15px;

    .control-legend__item {
      flex: 1 1 auto;
      margin: 5px 15px;
      max-width: 220px;

      &--reset {
        flex: 0 0 100%;

        .legend-item {
          background-color: #f0f0f0;
          border-radius: 4px;
          padding: 4px 8px;

          .text-legend {
            margin-left: 5px;
          }
        }
      }

      .legend-item {
        display: inline-block;
        opacity: 0.5;
        cursor: pointer;

        &--active {
          opacity: 1;
        }

        &__icon {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 99px;
          margin-right: 5px;
        }
      }
    }

    .control-legend__item--reset {
      max-width: unset;
    }

    @media #{map-get($media-breakpoints, 'mobile')} {
      margin: -5px -7.5px;

      .control-legend__item {
        margin: 5px 7.5px;
      }
    }
  }
}
</style>
